// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { profileManager, inventoryController, gameController, flowController } from "../../../game_theme/flow_fb/flowController";
import { ComponentButton } from "../../framework/components/ComponentButton";
import { ComponentLabel } from "../../framework/components/ComponentLabel";
import { ComponentPicture } from "../../framework/components/ComponentPicture";
import { ComponentSpine } from "../../framework/components/ComponentSpine";
import { tgfDictionary } from "../../framework/tgfDictionary";
import { tgfComponents } from "../../framework/components/tgfComponents";
import { tgfSettings } from "../../framework/tgfSettings";
import { CustomUpdateSettings } from "../../settings/Settings";
import { SoundManager } from "../../settings/SoundManager";
import { AngryAnalytics } from "../Analytics/Analytics";
import { angrybirds_regular_text, angrybirds_regular } from "../AssetDefinitions/FontDefinitions";
import { s_bar_container_green, s_profile_placeholder, s_portrait_empty, s_bar_timebg, s_btn_round_green_small, s_icon_play_small, s_btn_round_media_medium, s_icon_poke, s_bar_container_blue } from "../AssetDefinitions/ImageDefinitions";
import { s_notification } from "../AssetDefinitions/SpineDefinitions";
import { ExpManager } from "../ExpManager";
import { NudgeFactory } from "../NudgeFactory";
import { tgfHooks } from "../../framework/hooks/hooks";
import { ComponentLobbyListItem } from "../../framework/components/ComponentLobbyListItem";
tgfSettings.componentDefaults.componentAngryLobbyItem = {
    isLast: false,
    isItemNineSliced: false,
    sliceMargin: [],
    data: {},
    components: [] // Components to add as children
};
// The constructor for the component
/**
 * @constructor
 * @base ComponentBase
 */
export var AngryLobbyItem = function (properties) {
    "use strict";
    this.name = "AngryLobbyItem"; // The name of the component
    // Initialize properties
    this.initialize(tgfSettings.componentDefaults.componentAngryLobbyItem);
    // Set user properties
    if (properties !== undefined) {
        this.setProperties(properties);
    }
};
// Inherit the base component
tgfComponents.inherit(AngryLobbyItem, ComponentLobbyListItem);
AngryLobbyItem.prototype._parseData = function () {
    "use strict";
    var self = this;
    this.barButton = new ComponentButton({
        image: s_bar_container_green,
        createFromSlices: true,
        sliceMarginsArray: [10, 10, 10, 10],
        width: tgfSettings.lobbyScreenDialogProperties.nineSliceWidth,
        height: s_bar_container_green.height,
        x: s_bar_container_green.width / 2,
        y: s_bar_container_green.height / 2,
        onClick: function () {
            self._onActivePlayClick();
        },
        allowedTouchMotion: 30
    });
    var name = tgfDictionary.getText('OPPONENT_TEXT'), image = s_profile_placeholder, time = -1, playerID = '', stringTime = "∞ hr", matchInfo = {
        "hasWon": false,
        "mScore": 0,
        "oScore": 0
    };
    if (this.data) {
        if (this.data.info) {
            name = this.data.info.name;
            image = this.data.info.image;
            if (this.data.matchInfo) {
                matchInfo = this.data.matchInfo;
            }
            if (this.data.playerId) {
                playerID = this.data.playerId;
            }
            // if(this.data.data && this.data.data["lobby"]["timestamp"] && inventoryController){
            //     var ticketDuration = (72 * 60) * 60000;
            //     var timeDifference = inventoryController.serverTime - this.data.data["lobby"]["timestamp"];
            //     time = Math.floor(Math.floor(((ticketDuration - timeDifference) / 1000).toFixed(0) / 60) / 60);
            //     if(time < 1){
            //         stringTime = "< 1 hr";
            //     } else {
            //         stringTime = time.toString() + " hr";
            //     }
            // }
        }
        else if (this.data.isSuggested) {
            name = this.data.name;
            image = this.data.image ? this.data.image : s_profile_placeholder;
            playerID = this.data.id;
        }
    }
    var information = {
        hasWon: matchInfo["hasWon"],
        score: {
            player: matchInfo["mScore"],
            opponent: matchInfo["oScore"]
        },
        playerName: name,
        playerImage: image.clone()
    };
    information.playerImage.xOrigin = information.playerImage.width / 2;
    information.playerImage.yOrigin = information.playerImage.height / 2;
    this.playerProfileBG = new ComponentPicture({
        image: s_portrait_empty,
        xScale: 0.45,
        yScale: 0.45
    });
    var profileScale = profileManager.scaler(information.playerImage, 64);
    this.playerProfile = new ComponentPicture({
        image: information.playerImage,
        x: -255,
        y: 45,
        xScale: profileScale,
        yScale: profileScale
    });
    this.playerProfile.addComponent(this.playerProfileBG);
    if (playerID && !playerID.match((/[a-z]/i))) {
        var rank = ExpManager.getFriendRank(playerID);
        this.playerRankBG = new ComponentPicture({
            image: ExpManager.getRankAssets(rank).emblem,
            x: 0 - information.playerImage.xOrigin * profileScale,
            y: 55 - information.playerImage.yOrigin * profileScale,
            xScale: 0.25,
            yScale: 0.25
        });
        this.playerRank = new ComponentLabel({
            text: rank.toString(),
            font: {
                fontFace: angrybirds_regular_text.fontFace,
                fontSize: 18,
                fillColor: "#503d25",
                align: "center",
                textStyle: "italic",
                fontWeight: "bold",
                baseline: "middle"
            }
        });
        this.playerRankBG.addComponent(this.playerRank);
        this.playerProfile.addComponent(this.playerRankBG);
    }
    var fontColour = "#000000";
    switch (this.type) {
        case "new":
            //fontColour = "#ff0000"; // completed
            fontColour = "#343c39";
            break;
        case "active":
            fontColour = "#095618";
            //fontColour = "#00ff00"; // new
            break;
        case "suggested":
            fontColour = "#165150";
            break;
        case "inactive":
            fontColour = "#763a0e";
            //fontColour = "#0000ff"; // their turn
            break;
        case "done":
            fontColour = "#343c39";
            break;
        default:
            fontColour = "#095618";
            break;
    }
    this.usernameLabel = new ComponentLabel({
        x: -200,
        y: 41,
        text: information.playerName,
        font: {
            fontFace: angrybirds_regular.fontFace,
            fontSize: 32,
            fillColor: fontColour,
            fontStyle: 'bold',
            align: "left",
            baseline: "middle"
        }
    });
    this.timerBG = new ComponentPicture({
        image: s_bar_timebg,
        x: 170,
        y: 52,
        alpha: 0
    });
    // this.timerText = new ComponentLabel({
    //     x: 12,
    //     y: -5,
    //     text: stringTime,
    //     font:
    //     {
    //         fontFace: angrybirds_regular_text.fontFace,
    //         fontSize: 26,
    //         fillColor: "#095618",
    //         align: "middle",
    //         baseline: "middle"}
    // });
    // this.timerBG.addComponent(this.timerText);
    var buttonScale = 0.7;
    var buttonYOffset = -35;
    var smallButtonScale = 0.9;
    var smallButtonYOffset = -38;
    switch (this.type) {
        case "active":
            this.container.addComponent(this.barButton);
            this.container.addComponent(this.playerProfile);
            this.container.addComponent(this.usernameLabel);
            this.container.addComponent(this.timerBG);
            if (!inventoryController.showRefillNotification()) {
                this.exclamationMark = new ComponentSpine({
                    x: -300,
                    y: 5,
                    spineAnimation: s_notification,
                    animationClip: "notification_animation",
                    repeat: true
                });
                this.container.addComponent(this.exclamationMark);
            }
            this.buttonPlay = new ComponentPicture({
                x: 350 - s_btn_round_green_small.width * smallButtonScale / 2,
                y: 120 + smallButtonYOffset - s_btn_round_green_small.height * smallButtonScale / 2,
                xScale: smallButtonScale,
                yScale: smallButtonScale,
                image: s_btn_round_green_small
            });
            this.buttonPlayIcon = new ComponentPicture({
                image: s_icon_play_small,
                x: 3,
                y: 3
            });
            this.buttonPlay.addComponent(this.buttonPlayIcon);
            break;
        case "inactive":
            this.container.addComponent(this.playerProfile);
            this.container.addComponent(this.usernameLabel);
            this.container.addComponent(this.timerBG);
            if (this.data && this.data.data && this.data.data["lobby"] && (this.data.data["lobby"]["isRandomOpponent"] === false)) {
                this.buttonPlay = new ComponentButton({
                    x: 350,
                    y: 120 + smallButtonYOffset,
                    xScale: smallButtonScale,
                    yScale: smallButtonScale,
                    image: s_btn_round_media_medium,
                    icon: s_icon_poke,
                    iconPosition: "center",
                    canNudge: true,
                    onClick: function (comp) {
                        self._onInactivePlayClick(comp);
                    }
                });
            }
            break;
        case "inactiveEmpty":
            this.activeNewText = new ComponentLabel({
                x: s_bar_container_green.width / 2,
                y: s_bar_container_green.height / 2,
                font: {
                    fontFace: angrybirds_regular_text.fontFace,
                    fontSize: 24,
                    fillColor: "#763a0e",
                    align: "center",
                    baseline: "middle"
                },
                text: tgfDictionary.getText('THEIR_TURN_TEXT')
            });
            this.container.addComponent(this.activeNewText);
            break;
        case "done":
            this.container.addComponent(this.playerProfile);
            this.container.addComponent(this.usernameLabel);
            /*
            this.lossLight = new ComponentPicture({
                image: information.hasWon ? s_lamp_green : s_lamp_red,
                x: 360,
                y: 30,
                xScale: 0.7,
                yScale: 0.7
            });*/
            this.lossText = new ComponentLabel({
                x: 360,
                y: 42,
                text: information.hasWon ?
                    tgfDictionary.getText('WON_TEXT')
                    :
                        tgfDictionary.getText('LOST_TEXT'),
                font: {
                    fontFace: angrybirds_regular.fontFace,
                    fontSize: 32,
                    fillColor: information.hasWon ? "#4B7B00" : "#7B1700",
                    fontStyle: 'bold',
                    align: "right",
                    baseline: "middle"
                }
            });
            /*
            this.lossTextDetails = new ComponentLabel({
                x: -50,
                y: 34,
                text: (information.score.player.toString() + "/" + information.score.opponent.toString()),
                font:
                {
                    fontFace: angrybirds_regular_text.fontFace,
                    fontSize: 22,
                    fillColor: "#343c39",
                    align: "middle",
                    baseline: "middle"}
            });*/
            //this.lossText.addComponent(this.lossTextDetails);
            //this.lossLight.addComponent(this.lossText);
            //this.container.addComponent(this.lossLight);
            this.container.addComponent(this.lossText);
            break;
        case "suggested":
            this.barButton.image = s_bar_container_blue;
            this.barButton.id = playerID;
            this.barButton.onClick = function () {
                self._onSuggestedPlayClick(this);
            };
            this.container.addComponent(this.barButton);
            this.container.addComponent(this.playerProfile);
            this.container.addComponent(this.usernameLabel);
            this.buttonPlay = new ComponentPicture({
                x: 350 - s_btn_round_green_small.width * smallButtonScale / 2,
                y: 120 + smallButtonYOffset - s_btn_round_green_small.height * smallButtonScale / 2,
                xScale: smallButtonScale,
                yScale: smallButtonScale,
                image: s_btn_round_green_small
            });
            this.buttonPlayIcon = new ComponentPicture({
                image: s_icon_play_small,
                x: 3,
                y: 3
            });
            this.buttonPlay.addComponent(this.buttonPlayIcon);
            break;
        case "suggestedEmpty":
            // this should never happen though...
            break;
        case "doneEmpty":
            this.activeNewText = new ComponentLabel({
                x: s_bar_container_green.width / 2,
                y: s_bar_container_green.height / 2,
                font: {
                    fontFace: angrybirds_regular_text.fontFace,
                    fontSize: 24,
                    fillColor: "#343c39",
                    align: "center",
                    baseline: "middle"
                },
                text: tgfDictionary.getText('COMPLETED_MATCHES_TEXT')
            });
            this.container.addComponent(this.activeNewText);
            break;
        case "activeEmpty":
            this.activeNewText = new ComponentLabel({
                x: s_bar_container_green.width / 2,
                y: s_bar_container_green.height / 2,
                font: {
                    fontFace: angrybirds_regular_text.fontFace,
                    fontSize: 24,
                    fillColor: "#095618",
                    align: "center",
                    baseline: "middle"
                },
                text: tgfDictionary.getText('YOUR_TURN_TEXT')
            });
            this.container.addComponent(this.activeNewText);
            break;
    }
    if (this.buttonPlay) {
        this.container.addComponent(this.buttonPlay);
    }
    flowController.lobbyScreenDialog.storeLobbyItemComponent(this, this.type);
    // this.playerName = new ComponentLabel({
    //     text: this.data["data"]
    // })
};
AngryLobbyItem.prototype._onSuggestedPlayClick = function (comp) {
    flowController.lockLobby();
    AngryAnalytics.reportUXButton("suggested_friend");
    SoundManager.playEffect(SoundManager.UI_STATE.SELECT, SoundManager.UICollection, 0, false);
    tgfHooks.createContext(function () {
        //cb
        AngryAnalytics.reportSwitching();
        gameController.resumeOrStartNewGame(function () {
            flowController.freeLobby();
        }, null, gameController.onShowLobby, true); // onNewGame, onResume, onFail, allowNewGame
    }, comp.id, function (err) {
        if (err["code"] === "SAME_CONTEXT") {
            gameController.resumeOrStartNewGame(function () {
                flowController.freeLobby();
            }, null, gameController.onShowLobby, true); // onNewGame, onResume, onFail, allowNewGame 
            return;
        }
        flowController.unlockLobby();
    });
};
AngryLobbyItem.prototype._onActivePlayClick = function (comp) {
    var self = this;
    flowController.lobbyScreenDialog.toggleInput(false);
    SoundManager.playEffect(SoundManager.UI_STATE.SELECT, SoundManager.UICollection, 0, false);
    gameController.startPlay({ "url": self.data["id"] }, self.data.data["lobby"]["context"], self.data.data["lobby"]["isRandomOpponent"], false, false, self.data.data["lobby"], function () {
        flowController.freeLobby();
        AngryAnalytics.reportLobbyEntry(false, self.data.data["levelSettings"]["levelIndex"], self.data["id"]);
    }, function () {
        console.log("cancelled");
        flowController.lobbyScreenDialog.toggleInput(true);
    }, self.data.data["levelSettings"]["levelIndex"]);
};
AngryLobbyItem.prototype._onInactivePlayClick = function (comp) {
    "use strict";
    var self = this;
    SoundManager.playEffect(SoundManager.UI_STATE.SELECT, SoundManager.UICollection, 0, false);
    var nudgeMsg = NudgeFactory.GetPremadeNudge('update', 3, {});
    if (!comp.canNudge) {
        return;
    }
    if (self.data.context !== tgfHooks.getContextID()) {
        tgfHooks.switchContext(self.data.data["lobby"]["context"], function () {
            AngryAnalytics.reportSwitching();
            self.sendUpdate(comp, nudgeMsg);
        }, function (error) {
            if (error["code"] === "SAME_CONTEXT") {
                self.sendUpdate(comp, nudgeMsg);
            }
            else if (error["code"] === "USER_INPUT") {
                flowController.lobbyScreenDialog.toggleInput(true);
            }
            else {
                console.log("failed to switch context");
            }
        });
    }
    else {
        self.sendUpdate(comp, nudgeMsg);
    }
};
AngryLobbyItem.prototype.sendUpdate = function (comp, nudgeMsg) {
    "use strict";
    var self = this;
    AngryAnalytics.reportPokeClicked();
    if (tgfHooks.updateAsync) {
        self.buttonPlay.deactivate();
        self.buttonPlay.setAlpha(0);
        comp.canNudge = false;
        var localizations = NudgeFactory.GenerateCustomUpdateLocalization(CustomUpdateSettings.pokeMessage, [
            profileManager.getFirstName(tgfHooks.getPlayerID())
        ]);
        var CTAlocalizations = NudgeFactory.GenerateCustomUpdateLocalization(CustomUpdateSettings.pokeCTA);
        tgfHooks.updateAsync(function () { }, "poke", nudgeMsg, CTAlocalizations, // CTA
        localizations, { "tag": "custom_update" });
    }
};
